<template>
  <div class="dashboard-admin">
    <h1>HALOOO</h1>
  </div>
</template>

<script></script>

<style>
.dashboard-admin {
  background-color: aqua;
  /* height: 100vh; */
}
</style>
